import { Dropdown, Flex, MenuProps, Typography } from 'antd';
import React, { useState } from 'react';
import './SelectDropdown.scss';
import SelectInput from './SelectInput';
import { useSelector } from 'react-redux';
import { getAccounts } from 'shared/config/store/selectors/account';
import Option from './Option';

const { Text } = Typography;

type AccountDropdownProps = {
  label: string;
  defaultAccount: string;
  className?: string;
};

const SelectDropdown: React.FC<AccountDropdownProps> = ({
  label,
  defaultAccount,
  className,
}) => {
  const [selectedAccount, setSelectedAccount] = useState(defaultAccount);
  const accounts = useSelector(getAccounts);

  const options: MenuProps['items'] = Object.keys(accounts).map((key, idx) => ({
    key: String(idx),
    label: <Option onChange={() => setSelectedAccount(key)} option={key} />,
  }));

  return (
    <Flex vertical gap={8}>
      <Text>{label}</Text>

      <Dropdown
        menu={{
          items: options,
          selectable: true,
          defaultSelectedKeys: [selectedAccount],
        }}
        overlayStyle={{ maxHeight: 250, overflow: 'scroll', overflowX: 'hidden' }}
        placement="bottom"
        trigger={['click']}>

        <div>
          <SelectInput selectedAccount={selectedAccount} className={className} />
        </div>
      </Dropdown>
    </Flex>
  );
};

export default SelectDropdown;
